import { __assign } from "tslib";
import { createFakeDeleteResponder, createFakeGetResponder, createFakePutResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createInstagramApi, instagramRelativePath } from '.';
;
export var createInstagramApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createInstagramApi('', fakeHttp);
    var TestKit = {
        whenGetAccounts: function (validate) { return createFakeGetResponder(fakeHttp, instagramRelativePath + "/accounts?validate=" + !!validate); },
        whenUpdateAccountSettings: function (dto) { return createFakePutResponder(fakeHttp, instagramRelativePath + "/accounts/" + (dto === '*' ? '' : dto.id))(dto); },
        whenDisconnectAccount: function (id) { return createFakeDeleteResponder(fakeHttp, instagramRelativePath + "/accounts/" + id); },
    };
    return __assign(__assign({}, api), TestKit);
};
//# sourceMappingURL=testkit.js.map